import { createFileRoute } from "@tanstack/react-router"
import { queryClient } from "@/queryClient"
import { getCourseOptions, listAssignmentsOptions } from "@/client/@tanstack/react-query.gen"
import CourseFeedback from "@/routes/-pages/CourseFeedback"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

export const Route = createFileRoute("/course/$courseId/feedback")({
  loader: ({ params }) => {
    const { courseId } = params
    return runBackendModePrefetch(() =>
      Promise.all([
        queryClient.prefetchQuery(getCourseOptions({ path: { course_id: courseId } })),
        queryClient.prefetchQuery(listAssignmentsOptions({ path: { course_id: courseId }, query: { page_size: 100 } })),
      ]),
    )
  },
  component: CourseFeedback,
})
